export interface RequestExecption {
    name: "RequestException";
    message: string;
}

export interface Status {
    omfattasAvLma: boolean;
    hasArbetstillstand: boolean;
}

// Action types
export const SET_REQUEST_ERROR = 'SET_REQUEST_ERROR'
export const RESET_REQUEST_ERROR = 'RESET_REQUEST_ERROR';
export const SET_IS_LOADING_STATUS = 'SET_IS_LOADING_STATUS'
export const SET_STATUS = 'SET_STATUS'

// Actions
export type setRequestErrorAction = {
    type: typeof SET_REQUEST_ERROR;
    error: RequestExecption
}

export type resetRequestErrorAction = {
    type: typeof RESET_REQUEST_ERROR;
}

export type setIsLoadingStatusAction = {
    type: typeof SET_IS_LOADING_STATUS;
    isLoadingStatus: boolean
}

export type setStatusAction = {
    type: typeof SET_STATUS;
    status: Status | null
}

// Reducer state and action types
export interface GeneralState {
    requestError: RequestExecption | null,
    isLoadingStatus: boolean;
    status: Status | null
}

export type GeneralActionTypes =
    setIsLoadingStatusAction |
    setRequestErrorAction |
    resetRequestErrorAction |
    setStatusAction;
